import { Button, Col, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { UploadField } from "../../../Components/FormComponents/InputFields";
import { uploadDocumentsAPI } from "../../../Services/EmployeeOnboarding";
import ApproveReject from "./Component/ApproveReject";
import axios from "axios";

export default function UploadDocuments({ current, setCurrent }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const type = sessionStorage.getItem("userType");

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const { responseData, id, profileData } = useOutletContext();
  const [disabled, setDisabled] = useState({});
  const [isUpdate, setIsUpdate] = useState(false)
  console.log(disabled, "disabled", profileData);

  const onSubmit = async (val) => {
    const formData = new FormData();

    const appendSmartFile = (key, value) => {
      if (!value) return;

      if (Array.isArray(value)) {
        const file = value[0];
        if (!file) return;

        if (file instanceof File) {
          formData.append(key, file);
        } else if (file.originFileObj instanceof File) {
          formData.append(key, file.originFileObj);
        } else if (typeof file === "string" && file.startsWith("https://")) {
          // Skip URL, do not append to formData
          console.log(`Skipping URL for ${key}:`, file);
        }
      } else if (value instanceof File) {
        formData.append(key, value);
      } else if (value.originFileObj instanceof File) {
        formData.append(key, value.originFileObj);
      } else if (typeof value === "string" && value.startsWith("https://")) {
        // Skip URL, do not append to formData
        console.log(`Skipping URL for ${key}:`, value);
      }
    };

    // Append all fields
    appendSmartFile("passport_photo", val?.photo);
    appendSmartFile("updated_resume", val?.resume);
    appendSmartFile("pan_card", val?.pan);
    appendSmartFile("aadhaar_card", val?.aadhaar);
    appendSmartFile("relieving_letter", val?.relieving);
    appendSmartFile("salary_slips", val?.salary_slips);
    appendSmartFile("cancelled_cheque", val?.cheque);
    appendSmartFile("id_proof", val?.id_proof);
    appendSmartFile("tenth_certificate", val?.cert_10);
    appendSmartFile("twelfth_certificate", val?.cert_12);
    appendSmartFile("graduation_certificate", val?.grad);
    appendSmartFile("post_graduation_certificate", val?.pg);
    appendSmartFile("any_other", val?.any_other);

    // Check if FormData has any entries before uploading
    if ([...formData.entries()].length === 0) {
      if(
        !isUpdate
      ) {
 navigate("/new-user/nominees");
      }

   
     
      console.log("No files to upload, skipping API call.");
      api.error({
        message: "No files selected for upload.",
        placement: "top",
      });
      return;
    }

    // Debug what's being sent
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      const { data } = await uploadDocumentsAPI(formData,id,isUpdate);
      

      if (data?.success) {
        if(isUpdate) {
          console.log(isUpdate, 'retun')
         
            api.success({
          message: data?.message,
          placement: "top",
        });
          setIsUpdate(false);
          return
        }
        if (responseData?.final_submit) {
          handleSubmitFinal();
        } else {
          navigate("/new-user/nominees");
        }
        // api.success({
        //   message: data?.message,
        //   placement: "top",
        // });
        // navigate("/new-user/nominees");
      } else {
        api.error({
          message: data?.error || "Something went wrong",
          placement: "top",
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      api.error({
        message: "Upload failed. Please try again.",
        placement: "top",
      });
    }
  };

  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/nominees");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };
  const { documents_meta } = responseData?.final_submit || {};
  const is_Final_submit = documents_meta?.final_submit === true;

  const is_approve = documents_meta?.is_approved === true;

  useEffect(() => {
    const personal = responseData?.documents?.personal_documents;
    const edu = responseData?.documents?.educational_certificates;
    const personalProfile = profileData?.documents?.personal_documents;
    const eduProfile = profileData?.documents?.educational_certificates;

    if (!personal || !edu) return;

    const handleField = (name, profileVal, fallbackVal) => {
      if (profileVal) {
        if (Array.isArray(profileVal)) {
          const urls = profileVal
            .filter((item) => item?.url)
            .map((item) => item.url);
          setValue(name, urls);
        } else {
          setValue(name, [profileVal]);
        }
        setDisabled((prev) => ({ ...prev, [name]: true }));
      } else if (fallbackVal) {
        if (Array.isArray(fallbackVal)) {
          const urls = fallbackVal
            .filter((item) => item?.url)
            .map((item) => item.url);
          setValue(name, urls);
        } else {
          setValue(name, [fallbackVal]);
        }
        setDisabled((prev) => ({ ...prev, [name]: false }));
      } else {
        setValue(name, []);
        setDisabled((prev) => ({ ...prev, [name]: false }));
      }
    };

    // Personal Documents
    handleField(
      "photo",
      personalProfile?.passport_photos,
      personal?.passport_photos
    );
    handleField(
      "resume",
      personalProfile?.updated_resume?.url,
      personal?.updated_resume?.url
    );
    handleField("pan", personalProfile?.pan_card?.url, personal?.pan_card?.url);
    handleField(
      "aadhaar",
      personalProfile?.aadhaar_card?.url,
      personal?.aadhaar_card?.url
    );
    handleField(
      "relieving",
      personalProfile?.relieving_letter?.url,
      personal?.relieving_letter?.url
    );
    handleField(
      "salary_slips",
      personalProfile?.salary_slips,
      personal?.salary_slips
    );
    handleField(
      "cheque",
      personalProfile?.cancelled_cheque_passbook?.url,
      personal?.cancelled_cheque_passbook?.url
    );
    handleField(
      "id_proof",
      personalProfile?.id_proof?.url,
      personal?.id_proof?.url
    );

    // Educational Documents
    handleField(
      "cert_10",
      eduProfile?.tenth_certificate?.url,
      edu?.tenth_certificate?.url
    );
    handleField(
      "cert_12",
      eduProfile?.twelfth_certificate?.url,
      edu?.twelfth_certificate?.url
    );
    handleField(
      "grad",
      eduProfile?.graduation_certificate?.url,
      edu?.graduation_certificate?.url
    );
    handleField(
      "pg",
      eduProfile?.post_graduation_certificate?.url,
      edu?.post_graduation_certificate?.url
    );
    handleField(
      "any_other",
      eduProfile?.other_certificate?.url,
      edu?.other_certificate?.url
    );
  }, [responseData, profileData, setValue]);

  return (
    <>
      {contextHolder}
      <form className="responsive-form" onSubmit={handleSubmit(onSubmit)}>
        <Row className="align-content-start w-full">
            <Col className="flex justify-between" span={24}> 
                      <h3 className="color-heading"> Document Upload</h3>
          
                       {isUpdate &&  <Button onClick={()=>setIsUpdate(false)}  style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} shape="circle" icon={ <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                          </svg> }> 
                   </Button>||  <Button onClick={()=>setIsUpdate(true)}  style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} shape="circle" icon={<svg  xmlns="http://www.w3.org/2000/svg" width="16"  fill="currentColor" className="bi bi-pencil-fill m-auto " viewBox="0 0 16 16">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                      </svg>}> 
                   </Button> }
                  
                    </Col>
          {/* <Col className="px-3 mb-4 text-justify" span={24}>
            <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
              <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Document Upload
            </h2>
          </Col> */}

          {/* Document Upload Fields */}
          <UploadField
            id="photo"
            name="Passport Size Photograph (2 copies)"
            control={control}
            errors={errors}
            disabled={disabled?.photo}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="resume"
            name="Updated Resume"
            disabled={disabled?.resume}
            control={control}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="pan"
            name="PAN Card"
            control={control}
            disabled={disabled?.pan}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="aadhaar"
            name="Aadhar Card"
            control={control}
            disabled={disabled?.aadhaar}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="relieving"
            name="Relieving Letter"
            control={control}
            disabled={disabled?.relieving}
            errors={errors}
            // validations={{
            //   required: true,
            // }}
          />
          <UploadField
            id="salary_slips"
            name="Salary Slips (Last 3 months)"
            control={control}
            errors={errors}
            disabled={disabled?.salary_slips}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="cheque"
            name="Cancelled Cheque / Passbook"
            control={control}
            errors={errors}
            disabled={disabled?.cheque}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="id_proof"
            name="Passport / Driving License / Voter ID"
            control={control}
            errors={errors}
            disabled={disabled?.id_proof}
            // validations={{
            //   required: true,
            // }}
          />

          {/* Educational Certificates */}
          <Col className="px-3 mt-6 mb-4 text-justify" span={24}>
            <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
              <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Educational Certificates
            </h2>
          </Col>

          <UploadField
            id="cert_10"
            disabled={disabled?.cert_10}
            name="Upload 10th Certificate"
            control={control}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="cert_12"
            name="Upload 12th Certificate"
            control={control}
            disabled={disabled?.cert_12}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="grad"
            name="Upload Graduation Certificate"
            control={control}
            disabled={disabled?.grad}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <UploadField
            id="pg"
            name="Upload Post Graduation Certificate"
            control={control}
            disabled={disabled?.pg}
            errors={errors}
          />
          <UploadField
            id="any_other"
            name="Any Other Certificate"
            control={control}
            disabled={disabled?.any_other}
            errors={errors}
          />
        </Row>
        <Row className="step-buttons-box justify-content-end pt-3 px-2">
          {type !== "admin" && (
            <button
              disabled={is_Final_submit}
              className="m-2 text-white step-button"
              type="submit"
            >
              Submit
            </button>
          ) || <>{isUpdate &&  <button
            
              className="m-2 text-white step-button"
              type="submit"
            >
              Update
            </button>}</>}{" "}
        </Row>
      </form>
      {type === "admin" && is_Final_submit && (
        <>
          {is_approve !== true && (
            <ApproveReject
              id={id}
              redirect="nominees"
              detailType={["documents"]}
            />
          )}
        </>
      )}{" "}
    </>
  );
}
